import { AutoMap } from "@automapper/classes";
import { BaseModel } from "../base/base.model";
import { convertUsing, createMap, forMember, mapFrom, mapWith } from '@automapper/core';
import { mapper } from "src/app/infrastructure/infrastructure-services/common/mapper";
import { CommonEnumData, CommonFilterModel } from "src/app/infrastructure/infrastructure-services/common/models/wrapper.model";
 
//Contact Employee ********************
export interface IBPContactEmployeesModel {
    cardCode: string,
    name: string,
    title: string | null,
    firstName: string,
    lastName: string,
    e_Mail: string,
    phone1: string,
    mobilePhone: string,
    position: string,
    profession: string,
    active: string,
    isActive: boolean,
    contactPersonCode: string,
}
export class BPContactEmployeesModel implements IBPContactEmployeesModel {
    @AutoMap() cardCode: string = "";
    @AutoMap() name: string = "";
    @AutoMap() title: string | null = null;// = "";
    @AutoMap() firstName: string = "";
    @AutoMap() lastName: string = "";
    @AutoMap() e_Mail: string = "";
    @AutoMap() phone1: string = "";
    @AutoMap() mobilePhone: string = "";
    @AutoMap() position: string = "";
    @AutoMap() profession: string = "";
    @AutoMap() active: string = "";
    @AutoMap() isActive!: boolean;
    @AutoMap() contactPersonCode: string = "";
    constructor() {
        createMap(mapper, BPContactEmployeesModel, BPContactEmployeesModelSAP,
            forMember(
                (destination) => destination.Name,
                mapFrom((source) => source.name)
            ),
            forMember(
                (destination) => destination.Title,
                mapFrom((source) => source.title)
            ),
            forMember(
                (destination) => destination.FirstName,
                mapFrom((source) => source.firstName)
            ),
            forMember(
                (destination) => destination.LastName,
                mapFrom((source) => source.lastName)
            ),
            forMember(
                (destination) => destination.E_Mail,
                mapFrom((source) => source.e_Mail)
            ),
            forMember(
                (destination) => destination.Phone1,
                mapFrom((source) => source.phone1)
            ),
            forMember(
                (destination) => destination.MobilePhone,
                mapFrom((source) => source.mobilePhone)
            ),
            forMember(
                (destination) => destination.Position,
                mapFrom((source) => source.position)
            ),
            forMember(
                (destination) => destination.Profession,
                mapFrom((source) => source.profession)
            ),
            forMember(
                (destination) => destination.Active,
                mapFrom((source) => (source.isActive == true ? 'tYES' : (source.isActive == false) ? 'tNO' : (source.active == 'Y') ? 'tYES' : (source.isActive == undefined) ? 'tNO' : (source.active == "") ? 'tNO' : 'tNO'))
            ),
 
            forMember(
                (destination) => destination.InternalCode,
                mapFrom((source) => source.contactPersonCode)
            )
        );
    }
}
export interface IBPContactEmployeesModelSAP {
    Name: string,
    Title?: string,
    FirstName: string,
    LastName: string,
    E_Mail: string,
    Phone1: string,
    MobilePhone: string,
    Position: string,
    Profession: string,
    Active: string,
    InternalCode: string,
}
export class BPContactEmployeesModelSAP implements IBPContactEmployeesModelSAP {
    @AutoMap() Name: string = "";
    @AutoMap() Title?: string = "";
    @AutoMap() FirstName: string = "";
    @AutoMap() LastName: string = "";
    @AutoMap() E_Mail: string = "";
    @AutoMap() Phone1: string = "";
    @AutoMap() MobilePhone: string = "";
    @AutoMap() Position: string = "";
    @AutoMap() Profession: string = "";
    @AutoMap() Active: string = "";
    @AutoMap() InternalCode: string = "";
 
    constructor() {
        createMap(mapper, BPContactEmployeesModel, BPContactEmployeesModelSAP,
            forMember(
                (destination) => destination.Name,
                mapFrom((source) => source.name)
            ),
            forMember(
                (destination) => destination.Title,
                mapFrom((source) => source.title)
            ),
            forMember(
                (destination) => destination.FirstName,
                mapFrom((source) => source.firstName)
            ),
            forMember(
                (destination) => destination.LastName,
                mapFrom((source) => source.lastName)
            ),
            forMember(
                (destination) => destination.E_Mail,
                mapFrom((source) => source.e_Mail)
            ),
            forMember(
                (destination) => destination.Phone1,
                mapFrom((source) => source.phone1)
            ),
            forMember(
                (destination) => destination.MobilePhone,
                mapFrom((source) => source.mobilePhone)
            ),
            forMember(
                (destination) => destination.Position,
                mapFrom((source) => source.position)
            ),
            forMember(
                (destination) => destination.Profession,
                mapFrom((source) => source.profession)
            ),
            forMember(
                (destination) => destination.Active,
                mapFrom((source) => (source.isActive == true ? 'tYES' : (source.isActive == false) ? 'tNO' : (source.active == 'Y') ? 'tYES' : (source.isActive == undefined) ? 'tNO' : (source.active == "") ? 'tNO' : 'tNO'))
            ),
            forMember(
                (destination) => destination.InternalCode,
                mapFrom((source) => source.contactPersonCode)
            )
 
        );
    }
}
 
//Address ************************
export interface IBPAddressesModel {
    cardCode: string,
    addressType: string,
    addressName: string,
    street: string,
    block: string,
    zipCode: string,
    city: string,
    county: string,
    country: string,
    countryName: string,
    state: string,
    stateName: string,
    streetNo: string,
    gstType: number,
    gstTypeName: string,
    gstin: string,
    isAsDefault: boolean,
    isBoolCopyToShipToAddressChecked: boolean,
    rowNum: string
    // billtoDefault: string
    // shiptoDefault: string
}
export class BPAddressesModel implements IBPAddressesModel {
    @AutoMap() cardCode: string = "";
    @AutoMap() addressType: string = "";
    @AutoMap() addressName: string = "";
    @AutoMap() countryName: string = "";
    @AutoMap() country: string = "";
    @AutoMap() street: string = "";
    @AutoMap() block: string = "";
    @AutoMap() streetNo: string = "";
    @AutoMap() city: string = "";
    @AutoMap() county: string = "";
    @AutoMap() state: string = "";
    @AutoMap() stateName: string = "";
    @AutoMap() zipCode: string = "";
    @AutoMap() gstType!: number;
    @AutoMap() gstTypeName: string = "";
    @AutoMap() gstin: string = "";
    @AutoMap() isAsDefault: boolean = false;
    @AutoMap() isBoolCopyToShipToAddressChecked: boolean = false;
    @AutoMap() rowNum: string = "";
    // @AutoMap() billtoDefault: string = "";
    // @AutoMap() shiptoDefault: string = "";
 
    constructor() {
        createMap(mapper, BPAddressesModel, BPAddressesModelSAP,
            forMember(
                (destination) => destination.AddressType,
                mapFrom((source) => (source.addressType == 'bo_BillTo' ? 'bo_BillTo' : 'bo_ShipTo'))
            ),
            forMember(
                (destination) => destination.AddressName,
                mapFrom((source) => source.addressName)
            ),
            forMember(
                (destination) => destination.Street,
                mapFrom((source) => source.street)
            ),
            forMember(
                (destination) => destination.Block,
                mapFrom((source) => source.block)
            ),
            forMember(
                (destination) => destination.ZipCode,
                mapFrom((source) => source.zipCode)
            ),
            forMember(
                (destination) => destination.City,
                mapFrom((source) => source.city)
            ),
            forMember(
                (destination) => destination.County,
                mapFrom((source) => source.county)
            ),
            forMember(
                (destination) => destination.Country,
                mapFrom((source) => source.country)
            ),
            forMember(
                (destination) => destination.State,
                mapFrom((source) => source.state)
            ),
            forMember(
                (destination) => destination.StreetNo,
                mapFrom((source) => source.streetNo)
            ),
            forMember(
                (destination) => destination.GstType,
                mapFrom((source) => source.gstType)
            ),
            forMember(
                (destination) => destination.GSTIN,
                mapFrom((source) => source.gstin)
            ),
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.cardCode)
            ),
            forMember(
                (destination) => destination.RowNum,
                mapFrom((source) => source.rowNum)
            ),
            // forMember(
            //     (destination) => destination.BilltoDefault,
            //     mapFrom((source) => source.billtoDefault)
            // ),
            // forMember(
            //     (destination) => destination.ShipToDefault,
            //     mapFrom((source) => source.shiptoDefault)
            // )
        );
    }
}
export interface IBPAddressesModelSAP {
    // CardCode: string,
    AddressType: string,
    AddressName: string,
    Street: string,
    Block: string,
    ZipCode: string,
    City: string,
    County: string,
    Country: string,
    // countryName: string,
    State: string,
    // stateName: string,
    StreetNo: string,
    GstType: number,
    GSTIN: string,
    //isAsDefault: boolean,
    //isBoolCopyToShipToAddressChecked: boolean
    BPCode: string,
    RowNum: string,
    // BilltoDefault: string;
    // ShipToDefault: string;
}
export class BPAddressesModelSAP implements IBPAddressesModelSAP {
    // @AutoMap() CardCode: string = "";
    @AutoMap() AddressType: string = "";
    @AutoMap() AddressName: string = "";
    @AutoMap() Street: string = "";
    @AutoMap() Block: string = "";
    @AutoMap() ZipCode: string = "";
    @AutoMap() City: string = "";
    @AutoMap() County: string = "";
    @AutoMap() Country: string = "";
    // @AutoMap() countryName: string = "";
    @AutoMap() State: string = "";
    // @AutoMap() stateName: string = "";
    @AutoMap() StreetNo: string = "";
    @AutoMap() GstType!: number;
    @AutoMap() GSTIN: string = "";
    // @AutoMap() isAsDefault: boolean = false;
    // @AutoMap() isBoolCopyToShipToAddressChecked: boolean = false;
    @AutoMap() BPCode: string = "";
    @AutoMap() RowNum: string = "";
    // @AutoMap() BilltoDefault: string = "";
    // @AutoMap() ShipToDefault: string = "";
    constructor() {
        createMap(mapper, BPAddressesModel, BPAddressesModelSAP,
            forMember(
                (destination) => destination.AddressType,
                mapFrom((source) => source.addressType)
            ),
            forMember(
                (destination) => destination.AddressName,
                mapFrom((source) => source.addressName)
            ),
            forMember(
                (destination) => destination.Street,
                mapFrom((source) => source.street)
            ),
            forMember(
                (destination) => destination.Block,
                mapFrom((source) => source.block)
            ),
            forMember(
                (destination) => destination.ZipCode,
                mapFrom((source) => source.zipCode)
            ),
            forMember(
                (destination) => destination.City,
                mapFrom((source) => source.city)
            ),
            forMember(
                (destination) => destination.County,
                mapFrom((source) => source.county)
            ),
            forMember(
                (destination) => destination.Country,
                mapFrom((source) => source.country)
            ),
            forMember(
                (destination) => destination.State,
                mapFrom((source) => source.state)
            ),
            forMember(
                (destination) => destination.StreetNo,
                mapFrom((source) => source.streetNo)
            ),
            forMember(
                (destination) => destination.GstType,
                mapFrom((source) => source.gstType)
            ),
            forMember(
                (destination) => destination.GSTIN,
                mapFrom((source) => source.gstin)
            ),
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.cardCode)
            ),
            forMember(
                (destination) => destination.RowNum,
                mapFrom((source) => source.rowNum)
            ),
            // forMember(
            //     (destination) => destination.BilltoDefault,
            //     mapFrom((source) => source.billtoDefault)
            // ),
            // forMember(
            //     (destination) => destination.ShipToDefault,
            //     mapFrom((source) => source.shiptoDefault)
            // )
        );
    }
}
 
//FiscalTaxIDCollection **********************
export interface IBPFiscalTaxIDCollectionModel {
    bpCode: string;
    taxId0: string;
}
export class BPFiscalTaxIDCollectionModel implements IBPFiscalTaxIDCollectionModel {
    @AutoMap() bpCode: string = "";
    @AutoMap() taxId0: string = "";
 
    constructor() {
        createMap(mapper, BPFiscalTaxIDCollectionModel, BPFiscalTaxIDCollectionModelSAP,
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.bpCode)
            ),
            forMember(
                (destination) => destination.TaxId0,
                mapFrom((source) => source.taxId0)
            )
        );
    }
}
export interface IBPFiscalTaxIDCollectionModelSAP {
    BPCode: string;
    TaxId0: string;
}
export class BPFiscalTaxIDCollectionModelSAP implements IBPFiscalTaxIDCollectionModelSAP {
    @AutoMap() BPCode: string = "";
    @AutoMap() TaxId0: string = "";
 
    constructor() {
        createMap(mapper, BPFiscalTaxIDCollectionModel, BPFiscalTaxIDCollectionModelSAP,
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.bpCode)
            ),
            forMember(
                (destination) => destination.TaxId0,
                mapFrom((source) => source.taxId0)
            )
        );
    }
}
 
//Bank Account **********************
export interface IBPBankAccountsModel {
    cardCode: string,
    bankCode: string,
    bankName: string,
    accountNo: string,
    accountName: string,
    bicSwiftCode: string,
    branch: string,
    country: string,
    countryName: string,
 
}
export class BPBankAccountsModel implements IBPBankAccountsModel {
    @AutoMap() cardCode: string = "";
    @AutoMap() bankCode: string = "";
    @AutoMap() bankName: string = "";
    @AutoMap() accountNo: string = "";
    @AutoMap() accountName: string = "";
    @AutoMap() bicSwiftCode: string = "";
    @AutoMap() branch: string = "";
    @AutoMap() country: string = "";
    @AutoMap() countryName: string = "";
 
    constructor() {
        createMap(mapper, BPBankAccountsModel, BPBankAccountsModelSAP,
            forMember(
                (destination) => destination.BankCode,
                mapFrom((source) => source.bankCode)
            ),
            forMember(
                (destination) => destination.AccountNo,
                mapFrom((source) => source.accountNo)
            ),
            forMember(
                (destination) => destination.AccountName,
                mapFrom((source) => source.accountName)
            ),
            forMember(
                (destination) => destination.BICSwiftCode,
                mapFrom((source) => source.bicSwiftCode)
            ),
            forMember(
                (destination) => destination.Branch,
                mapFrom((source) => source.branch)
            ),
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.cardCode)
            ),
            forMember(
                (destination) => destination.Country,
                mapFrom((source) => source.country)
            )
 
        );
    }
}
export interface IBPBankAccountsModelSAP {
    BankCode: string,
    AccountNo: string,
    AccountName: string,
    BICSwiftCode: string,
    Branch: string
    BPCode: string,
    Country: string,
}
export class BPBankAccountsModelSAP implements IBPBankAccountsModelSAP {
    @AutoMap() BankCode: string = "";
    @AutoMap() AccountNo: string = "";
    @AutoMap() AccountName: string = "";
    @AutoMap() BICSwiftCode: string = "";
    @AutoMap() Branch: string = "";
    @AutoMap() BPCode: string = "";
    @AutoMap() Country: string = "";
    constructor() {
        createMap(mapper, BPBankAccountsModel, BPBankAccountsModelSAP,
            forMember(
                (destination) => destination.BankCode,
                mapFrom((source) => source.bankCode)
            ),
            forMember(
                (destination) => destination.AccountNo,
                mapFrom((source) => source.accountNo)
            ),
            forMember(
                (destination) => destination.AccountName,
                mapFrom((source) => source.accountName)
            ),
            forMember(
                (destination) => destination.BICSwiftCode,
                mapFrom((source) => source.bicSwiftCode)
            ),
            forMember(
                (destination) => destination.Branch,
                mapFrom((source) => source.branch)
            ),
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.cardCode)
            ),
            forMember(
                (destination) => destination.Country,
                mapFrom((source) => source.country)
            )
 
        );
    }
}
 
//WithholdingTaxCollection **********************
export interface IBPWithholdingTaxCollectionModel {
    wtCode: string,
    bpCode: string
    cardCode: string,
 
}
export class BPWithholdingTaxCollectionModel implements IBPWithholdingTaxCollectionModel {
    @AutoMap() wtCode: string = "";
    @AutoMap() bpCode: string = "";
    @AutoMap() cardCode: string = "";
 
    constructor() {
        createMap(mapper, BPWithholdingTaxCollectionModel, BPWithholdingTaxCollectionModelSAP,
            forMember(
                (destination) => destination.WTCode,
                mapFrom((source) => source.wtCode)
            ),
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.bpCode)
            )
        );
    }
}
export interface IBPWithholdingTaxCollectionModelSAP {
    WTCode: string,
    BPCode: string
}
export class BPWithholdingTaxCollectionModelSAP implements IBPWithholdingTaxCollectionModelSAP {
    @AutoMap() WTCode: string = "";
    @AutoMap() BPCode: string = "";
 
    constructor() {
        createMap(mapper, BPWithholdingTaxCollectionModel, BPWithholdingTaxCollectionModelSAP,
            forMember(
                (destination) => destination.WTCode,
                mapFrom((source) => source.wtCode)
            ),
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.bpCode)
            )
        );
    }
}
 
export interface IAllEnumData {
    code: CommonFilterModel[];
    cardType: CommonFilterModel[];
    currencyType: CommonFilterModel[];
    businessPartnerType: CommonFilterModel[];
    assesseeType: CommonFilterModel[];
    gstType: CommonFilterModel[];
}
export class AllEnumData extends CommonEnumData implements IAllEnumData {
    @AutoMap() code: CommonFilterModel[] = [];
    @AutoMap() cardType: CommonFilterModel[] = [];
    @AutoMap() currencyType: CommonFilterModel[] = [];
    @AutoMap() businessPartnerType: CommonFilterModel[] = [];
    @AutoMap() assesseeType: CommonFilterModel[] = [];
    @AutoMap() gstType: CommonFilterModel[] = [];
}
//Main Master ********************************
export interface IBPMasterModel extends BaseModel {
    cardCode: string,
    cardName: string | null,
    cardType: string,
    groupCode: number,
    groupName: string,
    slpCode: number;
    slpName: string;
    currency: string,
    validName: string,
    currencyName: string,
    currentAccountBalance: number,
    openDeliveryNotesBalance: number,
    openOrdersBalance: number,
    openOpportunities: number,
    valid: string,
    frozen: string,
    subjectToWithholdingTax: string,
    wtCode: string,
    wtCodeName: string,
    wtName: string,
    withholdingTaxDeductionGroup: number,
    accrualCriteria: string,
    typeReport: string,
    typeReportName: string,
    e_Mail: string,
    contactPerson: string,
    businessType: string,
    businessTypeName: string,
    website: string,
    bpAddresses: IBPAddressesModel[],
    bpBranchAssignment: IBPBranchAssignmentModel[],
    contactEmployees: IBPContactEmployeesModel[],
    freeText: string,
    defaultBankCode: string,
    defaultBankName: string,
    bankCountry: string,
    defaultAccount: string,
    defaultBranch: string,
    linkedBusinessPartner: string,
    linkedBusinessPartnerName: string,
    payTermsGrpCode: number,
    payTermsGrpCodeName: string,
    billtoDefault: string,
    shipToDefault: string,
    bpFiscalTaxIDCollection: IBPFiscalTaxIDCollectionModel[],
    bpBankAccounts: IBPBankAccountsModel[],
    bpWithholdingTaxCollection: IBPWithholdingTaxCollectionModel[],
    enumData: IAllEnumData,
    priceListName: string,
    priceListNo: string,
    priceListNum: string,
    Attachments2_Lines: IAttachments2_LinesModel[],
    attachmentEntry: string | null,
 
 
 
}
export class BPMasterModel implements IBPMasterModel {
    @AutoMap() cardCode: string = "";
    @AutoMap() cardName: string = "";
    @AutoMap() cardType: string = "";
    @AutoMap() groupCode!: number;
    @AutoMap() slpCode!: number;
    @AutoMap() slpName: string = "";
    @AutoMap() validName: string = ""
    @AutoMap() groupName: string = "";
    @AutoMap() currency: string = "";
    @AutoMap() currencyName: string = "";
    @AutoMap() currentAccountBalance!: number;
    @AutoMap() openDeliveryNotesBalance!: number;
    @AutoMap() openOrdersBalance!: number;
    @AutoMap() openOpportunities!: number;
    @AutoMap() valid: any;
    @AutoMap() frozen: string = "";
    @AutoMap() subjectToWithholdingTax: string = "";
    @AutoMap() wtCode: string = "";
    @AutoMap() wtCodeName: string = "";
    @AutoMap() wtName: string = "";
    @AutoMap() withholdingTaxDeductionGroup!: number;
    @AutoMap() accrualCriteria: string = "";
    @AutoMap() typeReport: string = "";
    @AutoMap() typeReportName: string = "";
    @AutoMap() e_Mail: string = "";
    @AutoMap() contactPerson: string = "";
    @AutoMap() businessType: string = "";
    @AutoMap() businessTypeName: string = "";
    @AutoMap() website: string = "";
    @AutoMap(() => BPAddressesModel) bpAddresses: BPAddressesModel[] = [];
    @AutoMap(() => BPBranchAssignmentModel) bpBranchAssignment: BPBranchAssignmentModel[] = [];
    @AutoMap(() => BPContactEmployeesModel) contactEmployees: BPContactEmployeesModel[] = [];
    @AutoMap() freeText: string = "";
    @AutoMap() defaultBankCode: string = "";
    @AutoMap() defaultBankName: string = "";
    @AutoMap() bankCountry: string = "";
    @AutoMap() defaultAccount: string = "";
    @AutoMap() defaultBranch: string = "";
    @AutoMap() linkedBusinessPartner: string = "";
    @AutoMap() linkedBusinessPartnerName: string = "";
    @AutoMap() payTermsGrpCode!: number;
    @AutoMap() payTermsGrpCodeName: string = "";
    @AutoMap() billtoDefault: string = "";
    @AutoMap() shipToDefault: string = "";
    @AutoMap(() => BPFiscalTaxIDCollectionModel)
    bpFiscalTaxIDCollection: BPFiscalTaxIDCollectionModel[] = [];
    @AutoMap(() => BPBankAccountsModel)
    bpBankAccounts: BPBankAccountsModel[] = [];
    @AutoMap(() => BPWithholdingTaxCollectionModel)
    bpWithholdingTaxCollection: BPWithholdingTaxCollectionModel[] = [];
    @AutoMap() enumData: AllEnumData = new AllEnumData();
    @AutoMap() priceListNo: string = "";
    @AutoMap() priceListName: string = "";
    @AutoMap() priceListNum: string = "";
    @AutoMap(() => Attachments2_LinesModel)
    Attachments2_Lines: Attachments2_LinesModel[] = [];
    @AutoMap() attachmentEntry: string | null = null;
    constructor() {
        createMap(mapper, BPMasterModel, BPMasterModelSAP,
            forMember(
                (destination) => destination.CardCode,
                mapFrom((source) => source.cardCode)
            ),
            forMember(
                (destination) => destination.CardName,
                mapFrom((source) => source.cardName)
            ),
            forMember(
                (destination) => destination.CardType,
                mapFrom((source) => source.cardType)
            ),
            forMember(
                (destination) => destination.GroupCode,
                mapFrom((source) => source.groupCode)
            ),
            forMember(
                (destination) => destination.SalesPersonCode,
                mapFrom((source) => source.slpCode)
            ),
            forMember(
                (destination) => destination.Currency,
                mapFrom((source) => source.currency)
            ),
            forMember(
                (destination) => destination.CurrentAccountBalance,
                mapFrom((source) => source.currentAccountBalance)
            ),
            forMember(
                (destination) => destination.OpenDeliveryNotesBalance,
                mapFrom((source) => source.openDeliveryNotesBalance)
            ),
            forMember(
                (destination) => destination.OpenOrdersBalance,
                mapFrom((source) => source.openOrdersBalance)
            ),
            forMember(
                (destination) => destination.OpenOpportunities,
                mapFrom((source) => source.openOpportunities)
            ),
            forMember(
                (destination) => destination.Valid,
                mapFrom((source) => source.valid)
            ),
            forMember(
                (destination) => destination.Frozen,
                mapFrom((source) => source.frozen)
            ),
            forMember(
                (destination) => destination.SubjectToWithholdingTax,
                mapFrom((source) => source.subjectToWithholdingTax)
            ),
            forMember(
                (destination) => destination.WTCode,
                mapFrom((source) => source.wtCode)
            ),
            forMember(
                (destination) => destination.WithholdingTaxDeductionGroup,
                mapFrom((source) => source.withholdingTaxDeductionGroup)
            ),
            forMember(
                (destination) => destination.AccrualCriteria,
                mapFrom((source) => source.accrualCriteria)
            ),
            forMember(
                (destination) => destination.TypeReport,
                mapFrom((source) => source.typeReport)
            ),
            forMember(
                (destination) => destination.EmailAddress,
                mapFrom((source) => source.e_Mail)
            ),
            // forMember(
            //     (destination) => destination.ContactPerson,
            //     mapFrom((source) => source.contactPerson)
            // ),
            forMember(
                (destination) => destination.BusinessType,
                mapFrom((source) => source.businessType)
            ),
            forMember(
                (destination) => destination.Website,
                mapFrom((source) => source.website)
            ),
            forMember(
                (destination) => destination.ContactEmployees,
                mapWith(BPContactEmployeesModelSAP, BPContactEmployeesModel, (source) => source.contactEmployees)
            ),
            forMember(
                (destination) => destination.BPAddresses,
                mapWith(BPAddressesModelSAP, BPAddressesModel, (source) => source.bpAddresses)
            ),
            forMember(
                (destination) => destination.BPBranchAssignment,
                mapWith(BPBranchAssignmentSAP, BPBranchAssignmentModel, (source) => source.bpBranchAssignment)
            ),
            forMember(
                (destination) => destination.FreeText,
                mapFrom((source) => source.freeText)
            ),
            forMember(
                (destination) => destination.DefaultBankCode,
                mapFrom((source) => source.defaultBankCode)
            ),
            forMember(
                (destination) => destination.BankCountry,
                mapFrom((source) => source.bankCountry)
            ),
            forMember(
                (destination) => destination.DefaultAccount,
                mapFrom((source) => source.defaultAccount)
            ),
            forMember(
                (destination) => destination.DefaultBranch,
                mapFrom((source) => source.defaultBranch)
            ),
            forMember(
                (destination) => destination.LinkedBusinessPartner,
                mapFrom((source) => source.linkedBusinessPartner)
            ),
            forMember(
                (destination) => destination.PayTermsGrpCode,
                mapFrom((source) => source.payTermsGrpCode)
            ),
            forMember(
                (destination) => destination.BPWithholdingTaxCollection,
                mapWith(BPWithholdingTaxCollectionModelSAP, BPWithholdingTaxCollectionModel, (source) => source.bpWithholdingTaxCollection)
            ),
 
            forMember(
                (destination) => destination.BPFiscalTaxIDCollection,
                mapWith(BPFiscalTaxIDCollectionModelSAP, BPFiscalTaxIDCollectionModel, (source) => source.bpFiscalTaxIDCollection)
            ),
            forMember(
                (destination) => destination.BPBankAccounts,
                mapWith(BPBankAccountsModelSAP, BPBankAccountsModel, (source) => source.bpBankAccounts)
            ),
            forMember(
                (destination) => destination.PriceListNo,
                mapFrom((source) => source.priceListNo)
            ),
            // forMember(
            //     (destination) => destination.PriceListName,
            //     mapFrom((source) => source.priceListName)
            // ),
            forMember(
                (destination) => destination.PriceListNum,
                mapFrom((source) => source.priceListNum)
            ),
            forMember(
                (destination) => destination.AttachmentEntry,
                mapFrom((source) => source.attachmentEntry)
            ),
        );
    }
}
 
export interface IBPBranchAssignmentModel {
    bpCode: string,
    bplid: number,
    disabledForBP: string,
}
 
export class BPBranchAssignmentModel implements IBPBranchAssignmentModel {
    @AutoMap() bpCode: string = "";
    @AutoMap() bplid!: number;
    @AutoMap() disabledForBP: string = "";
    constructor() {
        createMap(mapper, BPBranchAssignmentModel, BPBranchAssignmentSAP,
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.bpCode)
            ),
            forMember(
                (destination) => destination.BPLID,
                mapFrom((source) => source.bplid)
            ),
            forMember(
                (destination) => destination.DisabledForBP,
                mapFrom((source) => source.disabledForBP)
            )
        )
    }
}
 
export interface IBPBranchAssignmentSAP {
    BPCode: string,
    BPLID: number,
    DisabledForBP: string
}
 
export class BPBranchAssignmentSAP implements IBPBranchAssignmentSAP {
    @AutoMap() BPCode: string = "";
    @AutoMap() BPLID!: number;
    @AutoMap() DisabledForBP: string = "";
    constructor() {
        createMap(mapper, BPBranchAssignmentModel, BPBranchAssignmentSAP,
            forMember(
                (destination) => destination.BPCode,
                mapFrom((source) => source.bpCode)
            ),
            forMember(
                (destination) => destination.BPLID,
                mapFrom((source) => source.bplid)
            ),
            forMember(
                (destination) => destination.DisabledForBP,
                mapFrom((source) => source.disabledForBP)
            )
        )
    }
}
 
//Main BP Master Model SAP **********************
export interface IBPMasterModelSAP {
    CardCode: string,
    CardName: string,
    CardType: string,
    GroupCode: number,
    SalesPersonCode: number,
    Currency: string,
    CurrentAccountBalance: number,
    OpenDeliveryNotesBalance: number,
    OpenOrdersBalance: number,
    OpenOpportunities: number,
    Valid: string,
    Frozen: string,
    SubjectToWithholdingTax: string,
    WTCode: string,
    WithholdingTaxDeductionGroup: number,
    AccrualCriteria: string,
    TypeReport: string,
    EmailAddress: string,
    ContactPerson: string,
    Address: string,
    BusinessType: string,
    Website: string,
    BPAddresses: IBPAddressesModelSAP[],
    ContactEmployees: IBPContactEmployeesModelSAP[],
    FreeText: string,
    DefaultBankCode: string,
    BankCountry: string,
    DefaultAccount: string,
    DefaultBranch: string,
    LinkedBusinessPartner: string,
    PayTermsGrpCode: number,
    BPFiscalTaxIDCollection: IBPFiscalTaxIDCollectionModelSAP[],
    BPBankAccounts: IBPBankAccountsModelSAP[],
    BilltoDefault: string,
    ShipToDefault: string,
    BPWithholdingTaxCollection: IBPWithholdingTaxCollectionModelSAP[],
    BPBranchAssignment: IBPBranchAssignmentSAP[],
    PriceListNo: string,
    // PriceListName:string,
    PriceListNum: string,
    AttachmentEntry: string | null,
    HouseBank: string | null,
     HouseBankCountry: string | null,
     HouseBankAccount: string | null
 
 
}
export class BPMasterModelSAP implements IBPMasterModelSAP {
    @AutoMap() CardCode: string = "";
    @AutoMap() CardName: string = "";
    @AutoMap() CardType: string = "";
    @AutoMap() GroupCode!: number;
    @AutoMap() SalesPersonCode!: number;
    @AutoMap() Currency: string = "";
    @AutoMap() CurrentAccountBalance!: number;
    @AutoMap() OpenDeliveryNotesBalance!: number;
    @AutoMap() OpenOrdersBalance!: number;
    @AutoMap() OpenOpportunities!: number;
    @AutoMap() Valid: string = "";
    @AutoMap() Frozen: string = "";
    @AutoMap() SubjectToWithholdingTax: string = "";
    @AutoMap() WTCode: string = "";
    @AutoMap() WithholdingTaxDeductionGroup!: number;
    @AutoMap() AccrualCriteria: string = "";
    @AutoMap() TypeReport: string = "";
    @AutoMap() EmailAddress: string = "";
    @AutoMap() ContactPerson: string = "";
    @AutoMap() Address: string = "";
    @AutoMap() BusinessType: string = "";
    @AutoMap() Website: string = "";
    @AutoMap(() => BPContactEmployeesModelSAP)
    ContactEmployees: BPContactEmployeesModelSAP[] = [];
 
    @AutoMap(() => BPAddressesModelSAP)
    BPAddresses: BPAddressesModelSAP[] = [];
 
    @AutoMap() FreeText: string = "";
    @AutoMap() DefaultBankCode: string = "";
    @AutoMap() BankCountry: string = "";
    @AutoMap() DefaultAccount: string = "";
    @AutoMap() DefaultBranch: string = "";
    @AutoMap() LinkedBusinessPartner: string = "";
    @AutoMap() PayTermsGrpCode!: number;
    @AutoMap() BilltoDefault: string = "";
    @AutoMap() ShipToDefault: string = "";
    @AutoMap(() => BPWithholdingTaxCollectionModelSAP) BPWithholdingTaxCollection: BPWithholdingTaxCollectionModelSAP[] = [];
    @AutoMap(() => BPBranchAssignmentSAP) BPBranchAssignment: BPBranchAssignmentSAP[] = [];
    @AutoMap(() => BPBankAccountsModelSAP)
    BPBankAccounts: BPBankAccountsModelSAP[] = [];
    @AutoMap(() => BPFiscalTaxIDCollectionModelSAP)
    BPFiscalTaxIDCollection: BPFiscalTaxIDCollectionModelSAP[] = [];
    @AutoMap() PriceListNo: string = "";
    // @AutoMap() PriceListName:string="";
    @AutoMap() PriceListNum: string = ""
    @AutoMap() AttachmentEntry: string | null = null
    @AutoMap() HouseBank: string | null = "-1";
    @AutoMap() HouseBankCountry: string | null= "IN";
    @AutoMap() HouseBankAccount: string | null ="";
 
    constructor() {
        createMap(mapper, BPMasterModel, BPMasterModelSAP,
            forMember(
                (destination) => destination.CardCode,
                mapFrom((source) => source.cardCode)
            ),
            forMember(
                (destination) => destination.CardName,
                mapFrom((source) => source.cardName)
            ),
            forMember(
                (destination) => destination.CardType,
                mapFrom((source) => source.cardType)
            ),
            forMember(
                (destination) => destination.GroupCode,
                mapFrom((source) => source.groupCode)
            ),
            forMember(
                (destination) => destination.SalesPersonCode,
                mapFrom((source) => source.slpCode)
            ),
            forMember(
                (destination) => destination.Currency,
                mapFrom((source) => source.currency)
            ),
            forMember(
                (destination) => destination.CurrentAccountBalance,
                mapFrom((source) => source.currentAccountBalance)
            ),
            forMember(
                (destination) => destination.OpenDeliveryNotesBalance,
                mapFrom((source) => source.openDeliveryNotesBalance)
            ),
            forMember(
                (destination) => destination.OpenOrdersBalance,
                mapFrom((source) => source.openOrdersBalance)
            ),
            forMember(
                (destination) => destination.OpenOpportunities,
                mapFrom((source) => source.openOpportunities)
            ),
            forMember(
                (destination) => destination.Valid,
                mapFrom((source) => source.valid)
            ),
            forMember(
                (destination) => destination.Frozen,
                mapFrom((source) => source.frozen)
            ),
            forMember(
                (destination) => destination.SubjectToWithholdingTax,
                mapFrom((source) => source.subjectToWithholdingTax)
            ),
            forMember(
                (destination) => destination.WTCode,
                mapFrom((source) => source.wtCode)
            ),
            forMember(
                (destination) => destination.WithholdingTaxDeductionGroup,
                mapFrom((source) => source.withholdingTaxDeductionGroup)
            ),
            forMember(
                (destination) => destination.AccrualCriteria,
                mapFrom((source) => source.accrualCriteria)
            ),
            forMember(
                (destination) => destination.TypeReport,
                mapFrom((source) => source.typeReport)
            ),
            forMember(
                (destination) => destination.EmailAddress,
                mapFrom((source) => source.e_Mail)
            ),
            // forMember(
            //     (destination) => destination.ContactPerson,
            //     mapFrom((source) => source.contactPerson)
            // ),
            forMember(
                (destination) => destination.BusinessType,
                mapFrom((source) => source.businessType)
            ),
            forMember(
                (destination) => destination.Website,
                mapFrom((source) => source.website)
            ),
            forMember(
                (destination) => destination.ContactEmployees,
                mapWith(BPContactEmployeesModelSAP, BPContactEmployeesModel, (source) => source.contactEmployees)
            ),
            forMember(
                (destination) => destination.BPAddresses,
                mapWith(BPAddressesModelSAP, BPAddressesModel, (source) => source.bpAddresses)
            ),
            forMember(
                (destination) => destination.BPBranchAssignment,
                mapWith(BPBranchAssignmentSAP, BPBranchAssignmentModel, (source) => source.bpBranchAssignment)
            ),
            forMember(
                (destination) => destination.FreeText,
                mapFrom((source) => source.freeText)
            ),
            forMember(
                (destination) => destination.DefaultBankCode,
                mapFrom((source) => source.defaultBankCode)
            ),
            forMember(
                (destination) => destination.BankCountry,
                mapFrom((source) => source.bankCountry)
            ),
            forMember(
                (destination) => destination.DefaultAccount,
                mapFrom((source) => source.defaultAccount)
            ),
            forMember(
                (destination) => destination.DefaultBranch,
                mapFrom((source) => source.defaultBranch)
            ),
            forMember(
                (destination) => destination.LinkedBusinessPartner,
                mapFrom((source) => source.linkedBusinessPartner)
            ),
            forMember(
                (destination) => destination.PayTermsGrpCode,
                mapFrom((source) => source.payTermsGrpCode)
            ),
            forMember(
                (destination) => destination.BPWithholdingTaxCollection,
                mapWith(BPWithholdingTaxCollectionModelSAP, BPWithholdingTaxCollectionModel, (source) => source.bpWithholdingTaxCollection)
            ),
 
            forMember(
                (destination) => destination.BPFiscalTaxIDCollection,
                mapWith(BPFiscalTaxIDCollectionModelSAP, BPFiscalTaxIDCollectionModel, (source) => source.bpFiscalTaxIDCollection)
            ),
            forMember(
                (destination) => destination.BPBankAccounts,
                mapWith(BPBankAccountsModelSAP, BPBankAccountsModel, (source) => source.bpBankAccounts)
            ),
            forMember(
                (destination) => destination.PriceListNo,
                mapFrom((source) => source.priceListNo)
            ),
            // forMember(
            //     (destination) => destination.PriceListName,
            //     mapFrom((source) => source.priceListName)
            // ),
            forMember(
                (destination) => destination.PriceListNum,
                mapFrom((source) => source.priceListNum)
            ),
            forMember(
                (destination) => destination.AttachmentEntry,
                mapFrom((source) => source.attachmentEntry)
            ),
        );
    }
}
export interface IAttachments2_LinesModel {
    AbsoluteEntry: number,
    LineNum: number,
    SourcePath: string
    FileName: string
    FileExtension: string
    AttachmentDate: string
}
export class Attachments2_LinesModel implements IAttachments2_LinesModel {
    AbsoluteEntry!: number
    LineNum!: number
    SourcePath: string = ""
    FileName: string = ""
    FileExtension: string = ""
    AttachmentDate: string = ""
}